import { AppShell } from '@mantine/core';
import { createAddAccountModal } from 'features/add-account';
import { createBlockAccountModal } from 'features/block-account';
import { createDeleteAccountModal } from 'features/delete-account';
import { createEditAccountModal } from 'features/edit-account';
import { createUnblockAccountModal } from 'features/unblock-account';
import { createAccountRegistry } from 'entities/account';
import { accountsPageModel } from '../../model';
import cls from './accounts-page.module.scss';

const AccountRegistry = createAccountRegistry(accountsPageModel.accountRegistryModel);

const AddAccountModal = createAddAccountModal(accountsPageModel.addAccountModel);

const BlockAccountModal = createBlockAccountModal(accountsPageModel.blockAccountModel);

const UnblockAccountModal = createUnblockAccountModal(accountsPageModel.unblockAccountModel);

const DeleteAccountModal = createDeleteAccountModal(accountsPageModel.deleteAccountModel);

const EditAccountModal = createEditAccountModal(accountsPageModel.editAccountModel);

export const AccountsPage = () => (
	<>
		<AppShell.Main className={cls.accountsPage}>
			<AccountRegistry
				className={cls.accountsPageAccountRegistry}
				emptyActionSlot={<AddAccountModal.Button />}
				topBarActionSlot={<AddAccountModal.Button />}
				tableTdActionSlot={(account) => (
					<div className={cls.accountsPageActions}>
						<EditAccountModal.ActionIcon modalData={account} />
						{account.isLocked ? (
							<UnblockAccountModal.ActionIcon modalData={account} />
						) : (
							<BlockAccountModal.ActionIcon modalData={account} />
						)}
						<DeleteAccountModal.ActionIcon modalData={account} />
					</div>
				)}
			/>
		</AppShell.Main>
		<EditAccountModal />
		<DeleteAccountModal />
		<BlockAccountModal />
		<UnblockAccountModal />
		<AddAccountModal />
	</>
);
